import React, { useState } from 'react';
import { YearByYearCommon } from './../browse/YearByYearCommon';
import { Header, Divider, Icon } from 'semantic-ui-react'

export function SongEvents(props) {
	const [childRendering, setChildRendering] = useState(true);
	return (
		<>
			{childRendering &&
				<>
					<Divider horizontal inverted>
						<Header as='h4' inverted>
							<Icon name='music outline' />
							Other Song Usage
						</Header>
					</Divider>
					<YearByYearCommon slim={true} song={props.song}
						urlParams={false} relatedRendered={(val) => setChildRendering(val)}/>
				</>
			}
		</>
	);
}